import React, { useState, useEffect,useRef } from "react";
import "./Contacts.css";
import { Form, Button } from "react-bootstrap";
import { endPoints } from "../../constant/Environment";
import { useSelector, useDispatch } from "react-redux";
import { Actions } from "../../redux/Actions/Actions";
import { addData } from "../../Utility/API";
import { useNavigate } from "react-router-dom";
import { AiTwotoneEyeInvisible, AiFillEyeInvisible } from "react-icons/ai";
import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";
import { Helmet } from "react-helmet";
import { PageVisit } from "../../Utility/API";
import ReCAPTCHA from "react-google-recaptcha";
import { BsEnvelopeFill} from "react-icons/bs";

const Contacts = () => {
  const [firstName, setFirstName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [description, setDescription] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const state = useSelector((state) => state);
  // Create a ref for the reCAPTCHA component
  const recaptchaRef = useRef(null);
  const onSubmit = async () => {
    if (!recaptchaToken) {
      ErrorToast("Please complete the reCAPTCHA verification.");
      return;
    }

    let data = {
      fullName: firstName,
      emaill: email,
      subject: subject,
      description: description,
      product: "",
      reason: "",
     // recaptchaToken,
    };
    let url = `${endPoints.api.EMAIL_SUPPORT}`;

    if (firstName && email && description && subject) {
      setIsLoading(true);
      await addData(url, data)
        .then((response) => {
          setIsLoading(false);
          if (response.data.status === "success") {
            SuccesToast("Thank you for contacting us.");
            setFirstName("");
            setEmail("");
            setSubject("");
            setDescription("");
            setDescription("");
            setRecaptchaToken(null);
            recaptchaRef.current?.reset(); // Reset reCAPTCHA
            setRecaptchaToken(null);
          } else {
            ErrorToast(response.data.message);
          }
        })
        .catch((error) => {
          setIsLoading(false);
          console.error(error);
        });
    } else {
      ErrorToast("Please enter all the details");
    }
  };

  useEffect(() => {
    PageVisit(state?.auth?.user?.idUser || "", "contact-us");
  }, []);

  const handleRecaptchaChange = (token) => {
    setRecaptchaToken(token);
  };

  return (
    <div>
      <Helmet>
        <title>BettDraft - Contact Us</title>
      </Helmet>
      <div className="container bg-color">
        <div className="inner-divspace">
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Toaster />
          </div>
          <div className="row" style={{marginTop:'50px',justifyContent: "center" }}>
        
            {isLoading && <Loader spinner={true} visible={isLoading} />}
            <div className="col-md-6">
           
              <div className="form-space-r">
          
                <div className="static-form form-style-2">
                  <Form className="my-form-layout1">
                  <h2>Contact Us</h2>
                    <Form.Label className="my-form-label">Name </Form.Label>
                    <Form.Group className="mb-3" controlId="first name">
                      <Form.Control
                        className="mt-o"
                        type="text"
                        placeholder="Name"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                      />
                    </Form.Group>
                    <Form.Label className="my-form-label">Email </Form.Label>
                    <Form.Group className="mb-3" controlId="last name">
                      <Form.Control
                        className="mt-o"
                        type="text"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </Form.Group>
                    <Form.Label className="my-form-label">Your Subject </Form.Label>
                    <Form.Group className="mb-3" controlId="Your Subject">
                      <Form.Control
                        className="mt-o"
                        type="text"
                        placeholder="Your Subject"
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                      />
                    </Form.Group>
                    <Form.Label className="my-form-label">Your Message </Form.Label>
                    <Form.Control
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                      as="textarea"
                      placeholder="Leave a comment here"
                      style={{ height: "190px" }}
                    />

                    <ReCAPTCHA
                      ref={recaptchaRef} // Attach ref to reCAPTCHA
                      sitekey="6Lf3rG4qAAAAAK6EtSke6UObz2hKZ2Q4MONUKu6e"
                      onChange={handleRecaptchaChange}
                      className="mt-4"
                    />

                    <Button
                      variant="primary"
                      className="save-btn mt-4"
                      onClick={onSubmit}
                      disabled={isLoading || !recaptchaToken}
                    >
                      Submit
                    </Button>
                  </Form>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="mail" style={{marginTop:"20px"}}>
                <h3 className="text-color">
                <BsEnvelopeFill/> : {" "}
                support@bettdraft.com
                </h3>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Contacts;
